import React from 'react'
import { Line } from 'react-chartjs-2'

import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from 'chart.js'

import { AccountScoredActivity } from 'modules/accountActivity/domain'

import styles from './styles.module.css'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

export const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    y: {
      display: false,
      grid: {
        display: false
      },
      ticks: {
        display: true
      },
      beginAtZero: true,
      min: 0,
      suggestedMax: 5
    },
    x: {
      display: false,
      grid: {
        display: false
      },
      ticks: {
        display: false
      }
    }
  },
  layout: {
    padding: 0
  }
}

export const ScoreChart = ({ score }: { score: AccountScoredActivity }) => {
  const { normalizedScore, historicalScores = [] } = score
  const lastScore = Math.min((historicalScores && historicalScores[7]) || 0, 5)
  const trend = Math.max(-5, Math.min(5, normalizedScore ?? 0) - lastScore)
  const baseColor = Math.abs(trend) < 1 ? '#505D67' : score.trend > 0 ? '#0C7331' : '#A32D22'

  const chartData = {
    labels: score.historicalScores?.map(() => ''),
    datasets: [
      {
        data: score.historicalScores,
        backgroundColor: Math.abs(trend) < 1 ? '#F3F6F8' : score.trend > 0 ? '#E5F8E2' : '#FEDCD8',
        borderColor: baseColor,
        borderWidth: 1,
        tension: 0.4,
        pointRadius: 0,
        animation: false,
        fill: true
      }
    ]
  }

  return (
    <div className={styles.scoreChartContainer}>
      {score.historicalScores && <Line options={options} data={chartData} />}
    </div>
  )
}

export default ScoreChart
